export const colorPalette = {
    amethystPurple: "#7F56D9",
    emeraldGreen: "#34A853",
    amberOrange: "#F49D1B",
    slateGray: "#4A5564",
    cobaltBlue: "#196DF7",
    royalPurple: "#6B46C1",
    lavenderPurple: "#805AD5",
    grapePurple: "#553C9A",
    plumPurple: "#6B46C1",
    eggplantPurple: "#5A67D8",
    forestGreen: "#2F855A",
    limeGreen: "#38A169",
    mintGreen: "#2F855A",
    jadeGreen: "#276749",
    sunsetOrange: "#D97706",
    tangerineOrange: "#DD6B20",
    apricotOrange: "#C05621",
    burntOrange: "#9C4221",
    charcoalGray: "#2D3748",
    stormGray: "#1A202C",
    pewterGray: "#2D3748",
    ashGray: "#4A5568",
    oceanBlue: "#2B6CB0",
    skyBlue: "#3182CE",
    denimBlue: "#2C5282",
    navyBlue: "#2A4365",
    azureBlue: "#2C5282",
    
};

export const roleColorPalette = {
    amethystPurple: {
        background: "#F4EBFF", // Lighter shade
        text: "#5A3EAA", // Darker color for text
    },
    emeraldGreen: {
        background: "#E6FFED",
        text: "#2C7A3A",
    },
    amberOrange: {
        background: "#FFF6E5",
        text: "#C56A10",
    },
    slateGray: {
        background: "#F1F5F9",
        text: "#2C3E50",
    },
    cobaltBlue: {
        background: "#EBF4FF",
        text: "#144EA8",
    },
    royalPurple: {
        background: "#F3E8FF",
        text: "#5332A1",
    },
    lavenderPurple: {
        background: "#F4EBFF",
        text: "#6848B0",
    },
    grapePurple: {
        background: "#F3E8FF",
        text: "#432874",
    },
    plumPurple: {
        background: "#F3E8FF",
        text: "#5332A1",
    },
    eggplantPurple: {
        background: "#E9D8FD",
        text: "#3B2C86",
    },
    forestGreen: {
        background: "#E6FFED",
        text: "#22543D",
    },
    limeGreen: {
        background: "#E6FFED",
        text: "#2A6B35",
    },
    mintGreen: {
        background: "#E6FFED",
        text: "#22543D",
    },
    jadeGreen: {
        background: "#D9FEE0",
        text: "#215737",
    },
    sunsetOrange: {
        background: "#FFF5E4",
        text: "#B55A03",
    },
    tangerineOrange: {
        background: "#FFF2F2",
        text: "#B54B10",
    },
    apricotOrange: {
        background: "#FFF2F2",
        text: "#964018",
    },
    burntOrange: {
        background: "#FFF2F2",
        text: "#7A3319",
    },
    charcoalGray: {
        background: "#EDF2F7",
        text: "#2D3748",
    },
    stormGray: {
        background: "#E2E8F0",
        text: "#1A202C",
    },
    pewterGray: {
        background: "#EDF2F7",
        text: "#2D3748",
    },
    ashGray: {
        background: "#E2E8F0",
        text: "#4A5568",
    },
    oceanBlue: {
        background: "#BEE3F8",
        text: "#2B6CB0",
    },
    skyBlue: {
        background: "#BEE3F8",
        text: "#3182CE",
    },
    denimBlue: {
        background: "#BEE3F8",
        text: "#2C5282",
    },
    navyBlue: {
        background: "#CBD5E0",
        text: "#2A4365",
    },
    azureBlue: {
        background: "#BEE3F8",
        text: "#2C5282",
    },
}

        
